<app-year-selector [(year)]="startYear" (yearChanged)="startYearChanged($event)"></app-year-selector>
<span>&nbsp;-&nbsp;</span>
<app-year-selector [(year)]="endYear" (yearChanged)="endYearChanged($event)"></app-year-selector>
